import React, { useState, useEffect } from 'react';
import { Col, Row } from 'components/Core/Grid';
import Select from 'components/Core/Select';
import HyperLink from 'components/Core/HyperLink';
import GatedSubscribeForm from '../GatedSubscribeForm';
import { RoofingFormContainer, FormContainer, BackButton } from './styles';
import EmbedForm from '../EmbeddableForm';
import RoofingAreaCalcForm, { RoofingAreaCalcResult } from './RoofingAreaCalc';
import RoofingMaterialsCalcForm, { RoofingMaterialsCalcResult } from './RoofingMaterialsCalc';
import RoofShingleCalcForm, { RoofShingleCalcResult } from './RoofShingleCalc';

const RoofingCalculator = ({ gatedForm, handleToggleClick, pathUrl, ...otherProps }) => {
  const [result, setResult] = useState({
    roofingArea: {
      estimatedArea: 0,
    },
    roofingMaterials: {
      bundlesOfShingles: 0,
      rollsOfRollRoofing: 0,
      rollsOf15Felt: 0,
      rollsOf30Felt: 0,
    },
    roofShingle: {
      roofArea: 0,
      shingles: 0,
      shingleBundles: 0,
    },
  });
  const [gateFormCookieIncrease, setGateFormCookieIncrease] = useState(0);
  const [calcType, setCalcType] = useState('roofingArea');
  const [showResult, setShowResult] = useState(false);
  const [formHeight, setFormHeight] = useState({
    roofingArea: 0,
    roofingMaterials: 0,
    roofShingle: 0,
  });

  useEffect(() => {
    const tmpFormHeight = { ...formHeight };
    Object.keys(formHeight).forEach((key) => {
      let selectedForm;
      if (key === 'roofingArea') {
        selectedForm = document.getElementById('roofing_area_calc_form');
      } else if (key === 'roofingMaterials') {
        selectedForm = document.getElementById('roofing_materials_calc_form');
      } else {
        selectedForm = document.getElementById('roof_shingle_calc_form');
      }
      tmpFormHeight[key] = selectedForm.offsetHeight + 125;
    });
    setFormHeight(tmpFormHeight);
  }, []);

  useEffect(() => {
    setShowResult(false);
    handleToggleClick && handleToggleClick(calcType);
  }, [calcType]);

  const onHandleChange = (_, value) => {
    setCalcType(value);
  };

  const handleResult = (values) => {
    setResult(values);
    setShowResult(true);
    setGateFormCookieIncrease(gateFormCookieIncrease + 1);
  };

  const onReCalc = () => {
    setShowResult(false);
  };

  return (
    <FormContainer isEmbed={otherProps.isEmbed} {...otherProps}>
      <div className="section-tool-page-form--wrapper">
        <div className="section-tool-page-form--container">
          <RoofingFormContainer>
            <Row>
              <Col lg={6} md={6} sm={24} xs={24} className="side">
                <div className="p-[25px_7px] flex-col items-start flex-shrink-0 hidden md:flex">
                  <div className="flex items-center gap-[10px] p-[0px_30px_22px_30px] w-full">
                    <h4 className="font-sofia-pro text-[22px] font-extrabold leading-[120%] tracking-[-0.66px] mb-0">
                      Calculators
                    </h4>
                  </div>
                  {[
                    { label: 'Roofing Area', id: 'roofingArea' },
                    { label: 'Roofing Materials', id: 'roofingMaterials' },
                    { label: 'Roof Shingle', id: 'roofShingle' },
                  ].map((element, index) => (
                    <div
                      key={index}
                      role="button"
                      tabIndex="0"
                      aria-pressed={calcType === index}
                      className={`flex h-[64px] p-[10px_30px] items-center flex-shrink-0 w-full rounded-[8px] cursor-pointer transition-all duration-500 ${
                        calcType === element.id
                          ? 'bg-white rounded-[6px] shadow-[0px_4px_6px_0px_rgba(11,26,33,0.10)]'
                          : ''
                      }`}
                      onClick={() => setCalcType(element.id)}
                    >
                      <p
                        className={`text-center font-sofia-pro text-[16px] leading-[120%] tracking-[-0.16px] m-0 transition-all duration-500 ${
                          calcType === element.id
                            ? 'text-titan-blue-3 font-extrabold'
                            : 'text-grey-6 font-normal'
                        }`}
                      >
                        {element.label}
                      </p>
                    </div>
                  ))}
                </div>
                <div className="p-[30px_20px_20px] bg-white mobile-selector">
                  <Select
                    className="roofing-calc-type-selector"
                    value={calcType}
                    options={[
                      { label: 'Roofing Area', value: 'roofingArea' },
                      { label: 'Roofing Materials', value: 'roofingMaterials' },
                      { label: 'Roof Shingle', value: 'roofShingle' },
                    ]}
                    handleChange={onHandleChange}
                    notRenderSelected
                  />
                </div>
              </Col>
              <Col lg={18} md={18} sm={24} xs={24}>
                <div className="relative overflow-hidden min-h-[638px]">
                  <div
                    className={`p-[10px_28px] md:p-[30px_28px] absolute inset-0 w-full h-full top-0 transform transition-transform duration-500 ${
                      showResult ? '-translate-x-full' : '-translate-x-0'
                    } `}
                  >
                    <GatedSubscribeForm
                      gatedForm={gatedForm}
                      increaseCookie={gateFormCookieIncrease}
                    >
                      <div
                        className="relative overflow-hidden form-container transition-all duration-500"
                        style={{ height: `${formHeight[calcType]}px` }}
                      >
                        <RoofingAreaCalcForm
                          pathUrl={pathUrl}
                          onSubmit={handleResult}
                          show={calcType === 'roofingArea'}
                        />
                        <RoofingMaterialsCalcForm
                          pathUrl={pathUrl}
                          onSubmit={handleResult}
                          show={calcType === 'roofingMaterials'}
                        />
                        <RoofShingleCalcForm
                          pathUrl={pathUrl}
                          onSubmit={handleResult}
                          show={calcType === 'roofShingle'}
                        />
                      </div>
                    </GatedSubscribeForm>
                  </div>
                  <div
                    className={`p-[40px_20px] absolute inset-0 w-full h-full top-0 bg-gray-100 transform transition-transform duration-500 ${
                      showResult ? '-translate-x-0' : 'translate-x-full'
                    }`}
                  >
                    <div
                      className={`w-full flex flex-col items-center justify-start h-full gap-[40px] ${
                        calcType === 'roofingArea' && 'px-[50px]'
                      }`}
                    >
                      {calcType === 'roofingArea' ? (
                        <RoofingAreaCalcResult result={result} />
                      ) : calcType === 'roofingMaterials' ? (
                        <RoofingMaterialsCalcResult result={result} />
                      ) : (
                        <RoofShingleCalcResult result={result} />
                      )}
                      <div className="flex flex-col items-center self-stretch gap-[20px]">
                        <BackButton onClick={onReCalc} btnText="Recalculate Results" />
                        <p className="mb-0 text-center">
                          Learn how we calculated this result&nbsp;
                          <HyperLink
                            href="#section-tool-page-content--container"
                            className="underline decoration-[var(--titan-blue-4)] decoration-1"
                          >
                            below
                          </HyperLink>
                          .
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </RoofingFormContainer>
        </div>
      </div>
    </FormContainer>
  );
};

export default EmbedForm(RoofingCalculator);
